export interface CreatedAt {
    year: number;
    month: number;
    month_name: string;
    day: number;
    dayOfWeek: string;
    h: string;
    m: string;
    s: string;
}

export interface UpdatedAt {
    year: number;
    month: number;
    month_name: string;
    day: number;
    dayOfWeek: string;
    h: string;
    m: string;
    s: string;
}

export interface Timezone {
    timezone_type: number;
    timezone: string;
}

export type FarsiDate = {
    year: number;
    month: number;
    month_name: string;
    day: number;
    dayOfWeek: string;
    h: string;
    m: string;
    s: string;
};

export interface BaseDate {
    year: number;
    month: number;
    month_name: string;
    day: number;
    dayOfWeek: string;
    h: string;
    m: string;
    s: string;
}

export interface Discount {
    id: number;
    code: string;
    amount: number;
    percent: number;
    is_percent: boolean;
}

export interface TermItem {
    id: number;
    title: string;
    text: string;
    created_at: CreatedAt;
    updated_at: UpdatedAt;
}

export interface Meta {
    current_page: number;
    from: number;
    last_page: number;
    links: {
        url?: string;
        label: string;
        active: boolean;
    }[];
    path: string;
    per_page: number;
    to: number;
    total: number;
}

export type User = {
    id: number;
    page_ids?: number[];
    username: string;
    email: string;
    mobile: string;
    first_name: string;
    last_name: string;
    image: string;
    balance: number;
    trial_page_id: number;
    trial_days_lefted: number;
    trial_started_at: {
        year: number;
        month: number;
        day: number;
        dayOfWeek: string;
        h: string;
        m: string;
        s: string;
    };
    trial_finished_at: {
        year: number;
        month: number;
        day: number;
        dayOfWeek: string;
        h: string;
        m: string;
        s: string;
    };
    registred_days: number;
    fcm_token: string;
    dob: number;
    how_found_us: string;
    app_help_active: number;
    unread_tickets: number;
    unread_alerts: number;
};

export type Field = {
    id: number;
    name: string;
    created_at: CreatedAt;
    updated_at: UpdatedAt;
    is_store: boolean;
};

export interface FieldsResponse {
    data: Field[];
}

export type StoreType = {
    type: string;
    name: string;
};

export interface TermsResponse {
    data: TermItem[];
}

export interface TourGuide {
    playtime_seconds: number;
    time: number;
    seen: number;
    id: number;
    url: string;
    hls: string;
    uri: string;
    title: string;
    description: string;
    image: string;
    guest: number;
}

export type ViewMode = 'legacy' | 'modern';
export type CalendarView = 'grid' | 'slide';

export const modes: readonly { key: ViewMode; label: string }[] = [
    { key: 'legacy', label: 'ساده' },
    { key: 'modern', label: 'پیشرفته' }
];

export const calendarModes: readonly {
    key: CalendarView;
    label: string;
}[] = [
    {
        key: 'grid',
        label: 'Grid View'
    },
    {
        key: 'slide',
        label: 'Slide View'
    }
];

export interface SliderItem {
    id: number;
    image: string;
    text: string;
}

export interface SearchItem {
    id: number;
    title: string;
    user: {
        id: number;
        username: string;
        first_name: string;
        last_name: string;
        image: string;
    };
    thumbnail: string;
}
